import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import "react-sliding-pane/dist/react-sliding-pane.css";
import { getAllRaces } from "../../service/backend-api-service";

const buttonStyle = {
    width: "100%",
    fontSize: "14px",
    fontWeight: "600",
    marginBottom: "3px",
    transition: "background-color 0.16s ease, color 0.16s ease, border-color 0.16s ease, transform 0.12s ease, box-shadow 0.16s ease",
    borderLeft: "3px solid transparent",
    borderRadius: "4px",
};

const RaceSlidingPane = props => {
    const [races, setRaces] = useState([]);
    const [clickedIndex, setClickedIndex] = useState(null);
    const [loaded, setLoaded] = useState(false);

    const handleSelect = (e, item, index) => {
        let allButtons = document.querySelectorAll("#raceButton");
        allButtons.forEach(aButton => {
            aButton.style.backgroundColor = '';
            aButton.style.color = '';
            aButton.style.borderLeftColor = '';
            aButton.style.boxShadow = '';
            aButton.style.fontSize = '';
        });
        e.currentTarget.style.backgroundColor = "#1a2035";
        e.currentTarget.style.color = "#f0b840";
        e.currentTarget.style.borderLeftColor = "#f0b840";
        e.currentTarget.style.boxShadow = "2px 0 8px rgba(26,32,53,0.15)";
        e.currentTarget.style.fontSize = "15px";
        setClickedIndex(index);
        setTimeout(() => setClickedIndex(null), 350);
        props.raceSelectHandler(item);
    };

    const formatDate = (dateInYYYYMMDD) => {
        const year = dateInYYYYMMDD.substring(0, 4);
        const month = dateInYYYYMMDD.substring(4, 6);
        const day = dateInYYYYMMDD.substring(6, 8);
        return day + "/" + month + "/" + year;
    };

    useEffect(() => {
        setLoaded(false);
        const fetchData = async () => {
            let date = props.selectionDate;
            let apiData = await getAllRaces(date);
            setRaces(apiData);
            setLoaded(true);
            let allButtons = document.querySelectorAll("#raceButton");
            allButtons.forEach(aButton => {
                aButton.style.backgroundColor = '';
            });
        };
        fetchData();
    }, [props.selectionDate]);

    const itemList = races.map((item, index) => (
        <Button
            key={item.raceVenue + index}
            id="raceButton"
            className={clickedIndex === index ? 'race-btn-pulse' : ''}
            style={{
                ...buttonStyle,
                animationDelay: `${index * 30}ms`,
                animation: loaded ? `fadeSlideIn 0.25s ease both` : 'none',
            }}
            onClick={(e) => handleSelect(e, item, index)}
            variant="secondary"
            size="sm"
        >
            {item.raceVenue} - {item.raceTime}
        </Button>
    ));

    return (
        <>
            <style>{`
                @keyframes fadeSlideIn {
                    from { opacity: 0; transform: translateX(-8px); }
                    to   { opacity: 1; transform: translateX(0); }
                }
            `}</style>
            <div style={{ padding: "6px 4px" }}>
                {itemList}
                <Button
                    id="raceButton"
                    className={clickedIndex === -1 ? 'race-btn-pulse' : ''}
                    style={{
                        ...buttonStyle,
                        marginTop: "6px",
                        borderTop: "1px solid rgba(26,32,53,0.12)",
                        paddingTop: "6px",
                    }}
                    onClick={(e) => handleSelect(e, { date: props.selectionDate, type: 'ALL' }, -1)}
                    variant="secondary"
                    size="sm"
                >
                    Meetings for {formatDate(props.selectionDate)}
                </Button>
            </div>
        </>
    );
};

export default RaceSlidingPane;
